<template>
  <div class="w-full p-4">
    <AuthForm ref="formRef" :model="form" :rules="rules" tone="app">
      <a-form-item name="mobile">
        <a-input v-model:value="form.mobile" placeholder="请输入手机号" size="large" class="w-full h-11" @press-enter="$emit('submit')" />
      </a-form-item>
      <a-form-item name="loginpass">
        <a-input-password v-model:value="form.loginpass" placeholder="请输入密码" size="large" class="w-full h-11" @press-enter="$emit('submit')" />
      </a-form-item>
    </AuthForm>
    <a-button type="primary" size="large" block :loading="loading" @click="$emit('submit')" class="!h-12 mt-6">
      登录
    </a-button>
    <div class="w-full flex justify-end text-sm text-slate-500 dark:text-white/60 pt-2.5">
      <span class="cursor-pointer hover:text-slate-700 dark:hover:text-white/80" @click="$emit('forget-password')">
        忘记密码
      </span>
    </div>
  </div>
</template>

<script>
import AuthForm from '@/components/AuthForm'

export default {
  name: 'PasswordLoginPanel',
  components: { AuthForm },
  props: {
    form: { type: Object, required: true },
    rules: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },
  emits: ['submit', 'forget-password'],
  methods: {
    validate () {
      return this.$refs.formRef.validate()
    },
    clearValidate () {
      this.$refs.formRef?.clearValidate()
    }
  }
}
</script>
